import React from 'react';
import './Spacing.scss';

type SpacingProps = {
    size?:
        | 'xx-small'
        | 'x-small'
        | 'small'
        | 'small-mid-medium'
        | 'small-medium'
        | 'x-medium'
        | 'medium'
        | 'medium-large'
        | 'large'
        | 'large-large'
        | 'x-large'
        | 'xx-large'
        | 'xxx-large'
        | 'xxxx-large';
};

export const Spacing: React.FC<SpacingProps> = ({ size = 'medium' }) => {

    const spacingClass = `spacing spacing-${size}`;

    return <div className={spacingClass}></div>;
};
